import { Link } from 'react-router-dom';
import { siteStats } from '@/mocks/movies';

export default function StatsBanner() {
  const stats = [
    { value: siteStats.totalMovies, label: '电影资源', icon: 'ri-film-line' },
    { value: siteStats.totalTvShows, label: '电视剧', icon: 'ri-tv-line' },
    { value: siteStats.totalVariety, label: '综艺节目', icon: 'ri-live-line' },
    { value: siteStats.totalAnime, label: '动漫资源', icon: 'ri-rocket-line' },
    { value: siteStats.dailyVisitors, label: '日活跃用户', icon: 'ri-user-heart-line' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10 bg-primary-500" aria-label="数据统计">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-white">海量影视资源，一站尽享</h2>
          <p className="text-sm text-white/70 mt-2">天堂影院汇聚全网热门影视内容，持续更新中</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center gap-2 p-4 rounded-xl bg-white/10">
              <div className="w-10 h-10 flex items-center justify-center text-white/80">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <span className="font-heading text-2xl md:text-3xl font-bold text-white">{stat.value}</span>
              <span className="text-xs text-white/70">{stat.label}</span>
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-6">
          <Link
            to="/category/movie"
            className="px-6 py-2.5 bg-white text-primary-600 hover:bg-white/90 text-sm font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            立即开始观影
          </Link>
        </div>
      </div>
    </section>
  );
}